<app-header-translator></app-header-translator>
<app-product-spotlight
    [title]="'CONDO.HEADER_TITLE' | translate"
    [textContent]="'CONDO.HEADER_TEXT' | translate"
    [imageFilePath]="'/files/assets/img/condo-spotlight.jpg'">
</app-product-spotlight>
<app-general *ngIf="showGeneralPage" (gotoQuestionPageEvent)="goToQuestionPage($event)" [policytype] = "policytype"  #general></app-general>
<app-questions *ngIf="showQuestionPage" (gotoGeneralPageEvent)="goToGeneralPage($event)" [policytype] = "policytype"  #questions></app-questions>
